import Vue from 'vue';
import './plugins/vuetify';
import axios from 'axios';
import App from './App.vue';


Vue.config.productionTip = false;

Vue.prototype.$http = axios;
Vue.prototype.$proxy = 'https://us-central1-beautifulstocks.cloudfunctions.net';

new Vue({
  render: h => h(App),
}).$mount('#app');
